/**
 * These constants are based off the breakpoints defined in _breakpoints.scss
 */
export const APP_BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1640,
} as const;

/** The year should only be greater than or equal than 2014 - as per requirement */
export const YEAR_FILTER = {
  minYearAllowed: 2014,
};

/** Grouped search has a hard limit of 20 results. */ export const MAX_GROUPED_API_RESULTS_ALLOWED = 20;

export const CacheExpiryForStoreInHours = 24;

export const IMG_FALLBACK_TEXT = 'Image not available';
export const NO_VARIANT_TEXT = 'Variant name not available';

// The maximum number of items that can be returned from trim-status/search
export const MAX_ALLOWED_TO_SEARCH = 300;
